import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Facebook, Instagram, Twitter } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

export default function Footer() {
  const { t } = useLanguage();
  
  return (
    <footer className="bg-mrc-navy text-white mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="space-y-4">
            <div className="flex items-center gap-3">
              <img 
                src="https://customer-assets.emergentagent.com/job_mwenkomerce/artifacts/xt1gnrb8_IMG_1789.png" 
                alt="MRC Boutique Logo" 
                className="h-12 w-auto bg-white p-1 rounded"
              />
              <span className="font-heading text-xl font-bold">MRC Boutique, LLC</span>
            </div>
            <p className="text-gray-300 text-sm">
              {t('footerTagline')}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-lg font-semibold mb-4">{t('quickLinks')}</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/products" className="text-gray-300 hover:text-mrc-orange transition-colors">
                  {t('allProducts')}
                </Link>
              </li>
              <li>
                <Link to="/products?category=Elektwonik" className="text-gray-300 hover:text-mrc-orange transition-colors">
                  {t('electronics')}
                </Link>
              </li>
              <li>
                <Link to="/products?category=Rad" className="text-gray-300 hover:text-mrc-orange transition-colors">
                  {t('clothing')}
                </Link>
              </li>
              <li>
                <Link to="/products?category=Bote" className="text-gray-300 hover:text-mrc-orange transition-colors">
                  {t('beauty')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Customer Service */}
          <div>
            <h4 className="font-heading text-lg font-semibold mb-4">{t('customerService')}</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/orders" className="text-gray-300 hover:text-mrc-orange transition-colors">
                  {t('trackOrder')}
                </Link>
              </li>
              <li>
                <span className="text-gray-300">{t('returns')}</span>
              </li>
              <li>
                <span className="text-gray-300">{t('faq')}</span>
              </li>
              <li>
                <span className="text-gray-300">{t('contactUs')}</span>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading text-lg font-semibold mb-4">{t('contactUs')}</h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-2 text-gray-300">
                <Mail className="h-4 w-4 text-mrc-orange" />
                <a href="mailto:mrc@mrcboutique.online" className="hover:text-mrc-orange transition-colors">
                  mrc@mrcboutique.online
                </a>
              </li>
              <li className="flex items-center gap-2 text-gray-300">
                <Phone className="h-4 w-4 text-mrc-orange" />
                <span>+1 (772) 475-5207</span>
              </li>
              <li className="flex items-center gap-2 text-gray-300">
                <MapPin className="h-4 w-4 text-mrc-orange" />
                <span>Miami, FL, USA</span>
              </li>
            </ul>
            {/* Social Links */}
            <div className="flex gap-4 mt-4">
              <a href="https://www.facebook.com/share/1Csi1am7Vj/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-mrc-orange transition-colors">
                <Facebook className="h-5 w-5" />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-mrc-orange transition-colors">
                <Instagram className="h-5 w-5" />
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-mrc-orange transition-colors">
                <Twitter className="h-5 w-5" />
              </a>
              <a href="https://www.tiktok.com/@un.simple.clic" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-mrc-orange transition-colors">
                <svg className="h-5 w-5" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
                </svg>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-gray-700 mt-8 pt-8 text-center">
          <p className="text-gray-400 text-sm">
            © {new Date().getFullYear()} MRC Boutique, LLC. {t('allRightsReserved')}
          </p>
        </div>
      </div>
    </footer>
  );
}
